import React, { useRef, useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useMsal } from "@azure/msal-react";
import { useTheme } from "@mui/material/styles";
import MobileStepper from "@mui/material/MobileStepper";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import Slide1 from "components/TheSolutionSlides/Slide1";
import Slide2 from "components/TheSolutionSlides/Slide2";
import Slide3 from "components/TheSolutionSlides/Slide3";
import Slide4 from "components/TheSolutionSlides/Slide4";
import Slide5 from "components/TheSolutionSlides/Slide5";
import Slide6 from "components/TheSolutionSlides/Slide6";
import Slide7 from "components/TheSolutionSlides/Slide7";
import Slide8 from "components/TheSolutionSlides/Slide8";
import Slide9 from "components/TheSolutionSlides/Slide9";
import Slide10 from "components/TheSolutionSlides/Slide10";
import Slide11 from "components/TheSolutionSlides/Slide11";
import Slide12 from "components/TheSolutionSlides/Slide12";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";

function Thesolution() {
  const iframeRef = useRef(null);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userRoles = activeAccount?.idTokenClaims?.roles || [];

  const [selectedRole, setSelectedRole] = useState(
    localStorage.getItem("selectedRole") || userRoles[0] || ""
  );

  useEffect(() => {
    const storedRole = localStorage.getItem("selectedRole");
    if (storedRole && selectedRole !== storedRole) {
      setSelectedRole(storedRole);
    }
  }, []);

  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);

  const slides = [
    <Slide1 key="slide-1" />,
    <Slide12 key="slide-12" />,
    <Slide2 key="slide-2" />,
    <Slide3 key="slide-3" />,
    <Slide4 key="slide-4" />,
    <Slide5 key="slide-5" />,
    <Slide6 key="slide-6" />,
    <Slide7 key="slide-7" />,
    <Slide8 key="slide-8" />,
    <Slide9 key="slide-9" />,
    <Slide10 key="slide-10" />,
    <Slide11 key="slide-11" />,
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox px={{ xs: 2, md: 4 }} py={{ xs: 2, md: 4 }} borderRadius="lg" shadow="md">
        <Grid container spacing={3} alignItems="center" justifyContent="center">
          <Grid item xs={12}>
            <MDBox
              bgColor="rgba(148, 148, 148, 0.07)"
              borderRadius="md"
              p={{ xs: 2, sm: 3 }}
              fontSize={{ xs: "16px", sm: "18px", md: "20px" }}
              fontWeight="500"
              textAlign="center"
              minHeight={{ xs: "auto", sm: "500px", md: "700px" }}
              maxHeight={{ xs: "auto", sm: "500px", md: "700px" }}
              overflowY="auto"
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{
                boxShadow: "0px 8px 20px rgba(0, 0, 0, 0)",
                backdropFilter: "blur(15px)",
                color: "white",
                WebkitOverflowScrolling: "touch",

                // iPad Pro fix — targets ~12.9" screens
                "@media (min-width: 1024px) and (max-width: 1400px) and (min-height: 1100px)": {
                  maxHeight: "450px",
                },
              }}
            >
              {slides[activeStep]}
            </MDBox>
          </Grid>

          <Grid item xs={12}>
            <MobileStepper
              steps={slides.length}
              position="static"
              activeStep={activeStep}
              nextButton={
                <MDButton
                  size="medium"
                  onClick={handleNext}
                  disabled={activeStep === slides.length - 1}
                  color="secondary"
                >
                  Next
                  {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </MDButton>
              }
              backButton={
                <MDButton
                  size="medium"
                  onClick={handleBack}
                  disabled={activeStep === 0}
                  color="secondary"
                >
                  {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                  Back
                </MDButton>
              }
              sx={{
                background: "linear-gradient(to right, #42424a, #191919)",
                borderRadius: "8px",
                padding: "12px 24px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
                "& .MuiMobileStepper-dot": {
                  backgroundColor: "#ccc",
                },
                "& .MuiMobileStepper-dotActive": {
                  backgroundColor: "#00759C",
                },
              }}
            />
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Thesolution;
